export const serializeSource = source => ({
  title: source.title,
  id: source.id,
});

export const serializeSourceToMap = sources =>
  sources.map(source => serializeSource(source));
